import { useParams } from 'quartz-routing/react-router';
export const replacePlaceholderWithPortalId = (portalId, path) => path.replace(/\/l\//g, `/${portalId}/`);
export const useIsOnOwnProfile = () => {
  const {
    userId
  } = useParams();
  return !userId;
};